import React from 'react';
import styled from '@emotion/styled';

import { parseHtml } from '../helpers';

import { ProductComponentProps } from '../../types/types';

import { productComponentContainerPaddingStyle, productComponentContainerBottomPaddingStyle } from '../shared/styles';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const DisclaimerContainer = styled.div(productComponentContainerPaddingStyle, {
  // z-index is 1 here because this component doesn't allow the header pattern to overlap
  backgroundColor: 'var(--color-white)',
  position: 'relative',
  zIndex: 1,

  paddingBottom: pxToRem(48),

  [mqBreakpoints.tablet]: {
    paddingBottom: pxToRem(64),
  },

  [mqBreakpoints.desktop]: {
    paddingBottom: pxToRem(80),
  },
});

const P = styled.p({
  fontSize: pxToRem(14),
  fontWeight: 'var(--font-weight-light)',
  paddingBottom: 0,

  '& strong': {
    fontWeight: 'var(--font-weight-medium)',
  },
});

export const Disclaimer: React.FC<ProductComponentProps> = props => {
  const { description } = props.productComponent;
  const componentIdx = props.index ?? 0;

  return (
    <DisclaimerContainer id={`mp-product-disclaimer-${componentIdx}`} data-testid='mp-product-disclaimer'>
      {description ? <P data-testid='mp-product-disclaimer-description'>{parseHtml(description)}</P> : null}
    </DisclaimerContainer>
  );
};
